import { LoadingSkeleton } from 'sonata-react-components';

import { AdvertiserCampaignSkeletonStyled } from './AdvertiserCampaignSkeleton.styled';

const AdvertiserCampaignSkeleton = () => {
  return (
    <AdvertiserCampaignSkeletonStyled className="advertiserCampaignSkeleton">
      <div className="advertiserCampaignSkeleton__firstLine">
        {Array.from({ length: 2 }).map((_, index) => (
          <div className="advertiserCampaignSkeleton__firstLineItem" key={index}>
            <LoadingSkeleton height={16} width={163} />
            <LoadingSkeleton height={40} />
          </div>
        ))}
      </div>
      <div className="advertiserCampaignSkeleton__secondLine">
        {Array.from({ length: 2 }).map((_, index) => (
          <div className="advertiserCampaignSkeleton__secondLineItem" key={index}>
            <LoadingSkeleton height={16} width={163} />
            <LoadingSkeleton height={40} />
          </div>
        ))}
      </div>
    </AdvertiserCampaignSkeletonStyled>
  );
};

export default AdvertiserCampaignSkeleton;
